import { render, staticRenderFns } from "./AddBlog.vue?vue&type=template&id=5169077e&scoped=true&"
import script from "./AddBlog.vue?vue&type=script&lang=js&"
export * from "./AddBlog.vue?vue&type=script&lang=js&"
import style0 from "./AddBlog.vue?vue&type=style&index=0&id=5169077e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169077e",
  null
  
)

export default component.exports